import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

import Data from 'components/Data';

import ShareableResourceDetails from 'components/layout/shareable/ShareableResourceDetails';

class ShareableResource extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      show: false,
    };
  }

  show = e => {
    e.preventDefault();
    this.setState({ show: true });
  };

  close = () => {
    this.setState({ show: false });
  };

  render() {
    const {
      intl: { messages },
      type,
      id,
      className,
      data,
    } = this.props;
    const { show } = this.state;

    return (
      <>
        {show && <Data dataName="shareableResource" url={`/api/sharedresources/${type}/${id}.json`} />}

        <a href="#shareMenu" onClick={this.show} className={className}>
          <i className="fal fa-share" /> {messages.share}
        </a>

        <ShareableResourceDetails show={show} close={this.close} data={data} type={type} id={id} />
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    data: state.data.shareableResource,
  };
};

export default injectIntl(connect(mapStateToProps)(ShareableResource));
